import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Rimuove il loader iniziale non appena React è montato
const bootLoader = document.getElementById("boot-loader");
if (bootLoader) {
  bootLoader.remove();
}
